<template>
  <tm-loader
    class="content-loading-block"
    :title="title"
    :description="description"
  />
</template>

<script setup lang="ts">
import TmLoader from '@/components/shared/TmLoader.vue'

defineProps<{
  title: string
  description: string
}>()
</script>

<style lang="scss" scoped>
.content-loading-block {
  padding-top: 123px;
  padding-bottom: 123px;
  min-height: 372px;
}
</style>
